import React from 'react';
import { moneyUtils, ParkingCard } from '@sato/components';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import { ParkingSpaceContractItem } from '@hooks/useParkingSpaceContracts';
import { localizationStore, t } from '@stores/localization';

import { getParkingSpaceFeaturesText } from '../parking.utils';

type Props = {
  parkingContract: ParkingSpaceContractItem;
  className?: string;
};

/** Renders a ParkingCard from given contract */
export const ParkingCardFromParkingContract = observer(
  ({ parkingContract: { parkingSpace, grossTotal }, className }: Props) => {
    if (!parkingSpace) return null;

    const formattedPrice = moneyUtils.formatMoney(
      { currency: 'EUR', value: grossTotal },
      localizationStore.locale.locale
    );

    return (
      <ParkingCard
        address={parkingSpace.name}
        title={t(`parking.${parkingSpace.type}`)}
        body={getParkingSpaceFeaturesText(parkingSpace, t)}
        spaceNumber={parkingSpace.labelId}
        priceLabel={`${formattedPrice} / ${t('month_unit')}`}
        className={classNames('lg:max-w-md', className)}
      />
    );
  }
);
